import React from 'react'
import { Link } from 'react-router-dom'
import styles from '../../styles/components/PageHeader.module.scss'
import arrowLeft from '../../shared/images/icon-arrow-left.svg'

interface PageHeaderProps {
  /** Path to navigate to via Link (use this for static back destinations) */
  backTo?: string
  /** Callback for programmatic back navigation, e.g. navigate(-1) */
  onBack?: () => void
  /** Optional page title rendered as h2 */
  title?: string
  /** Optional subtitle rendered as p */
  subtitle?: string
}

const PageHeader: React.FC<PageHeaderProps> = ({ backTo, onBack, title, subtitle }) => {
  return (
    <div className={styles.PageHeader}>
      {backTo ? (
        <Link to={backTo} className={styles.arrowLink}>
          <img src={arrowLeft} alt='Arrow Left' />
        </Link>
      ) : (
        <button className={styles.arrowButton} onClick={onBack} type='button'>
          <img src={arrowLeft} alt='Arrow Left' />
        </button>
      )}
      {title && <h2>{title}</h2>}
      {subtitle && <p>{subtitle}</p>}
    </div>
  )
}

export default PageHeader
